// extracted by mini-css-extract-plugin
module.exports = {"postsContainer":"BlogPosts_postsContainer__nwPGl"};